<script setup lang="ts">
import { type PropType, toRaw } from 'vue';
import { CommonUtils } from '@/utils/commonUtils';
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig';
import type { RouterItem } from '@/api';
import { useRenderIcon } from '@/components/ReIcon/src/hooks'
import { checkAndNavigate } from '@/utils/redirect';
import { isAllEmpty } from '@pureadmin/utils';
const sysStore = useSystemConfigStoreHook();
const props = defineProps({
  products: {
    type: Array as PropType<RouterItem[]>,
    required: true,
  },
  activePath: {
    type: String,
    required: true
  }
});

const isChildActive = (child: RouterItem) => {
  return props.activePath === child.path;
};
const handleClick = (child: any) => {
  if (isAllEmpty(child?.path)) {
    return;
  }
  if (child?.path?.startsWith('http')) {
    window.open(child.path, '_blank');
  } else {
    checkAndNavigate(child?.path);
  }
}
</script>

<template>
  <div class="flex flex-wrap gap-8 py-[30px]">
    <div v-for="child in props.products" :key="child?.id" class="flex flex-col">
      <div class="text-lg  font-bold ">
        <div
          @click="handleClick(child)"
          class="product-item  flex  hover:bg-[#F7F7F7] px-[21px] py-[14px] rounded-lg transition-all duration-300"
          :class="{ 'bg-[#F7F7F7]': isChildActive(child) }">
          <div
            class="bg-white nav-box-shadow rounded-[10px] w-[24px] h-[24px]   flex items-center justify-center transform transition-transform duration-300">
            <component class="text-main-primary" v-if="child.icon" :is="useRenderIcon(
              toRaw(child?.icon)
            )" />
            <div v-else class="w-[14px] h-[14px] bg-main-primary rounded-full"></div>
          </div>
          <div class="flex flex-col ml-[8px]">
            <div class="text-sm text-[#3D3D3D] text-[16px] transition-colors duration-300 nav-name"
              :class="{ 'text-main-primary': isChildActive(child) }">
              {{ CommonUtils.getTranslateText(child.title, sysStore.currentLang) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.nav-box-shadow {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product-item {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.product-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.product-item:hover .nav-box-shadow {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.product-item:hover .nav-name {
  color: var(--color-main-primary);
}
</style>
